import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChatBubble7: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chat-bubble-7"><path d="M12 2.5C17.483 2.5 22 6.71457 22 12C22 17.2854 17.483 21.5 12 21.5C10.3775 21.5 8.84187 21.1327 7.4834 20.4785C7.40271 20.4397 7.31798 20.4324 7.24512 20.4512C6.14483 20.735 5.01314 20.91 3.82422 20.9834C3.56955 20.9991 3.32383 20.8844 3.17285 20.6787C3.02214 20.4731 2.98592 20.2049 3.07715 19.9668C3.38167 19.1726 3.63926 18.3875 3.81836 17.5928C3.82791 17.5504 3.8228 17.4713 3.75586 17.3789C2.65015 15.852 2 13.9985 2 12C2 6.71457 6.51697 2.5 12 2.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconChatBubble7;
